import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import Log from './Log';
import AdminAuthContainer from '../AdminAuthContainer';
import { CloudWatchLogContext } from '../CloudWatchLogContext';

export const CloudWatchLogsView = () => {
    const { t } = useTranslation('portal');
    const { cloudWatchLogs, isLoading, allLoaded, setSearchText } = useContext(CloudWatchLogContext);
    const { authMode } = useContainer(AdminAuthContainer);
    console.log('ClassSessionDetailLog authMode', authMode);

    return (
        <div style={{ minWidth: '600px', padding: '20px', border: '1px solid rgb(240,240,240)', borderRadius: '4px' }}>
            {cloudWatchLogs.map((item, i) => {
                let parsedItem: any;
                try {
                    parsedItem = JSON.parse(item.message);
                } catch (err) {
                    return <></>;
                }
                return <Log item={parsedItem} setSearchText={setSearchText} key={i} />;
            })}
            {isLoading && !allLoaded ? <div>{t('loading')}</div> : <></>}
            {!isLoading && allLoaded && cloudWatchLogs && cloudWatchLogs.length === 0 && (
                <div>{t('no-logs-found')}</div>
            )}
        </div>
    );
};
